<template>
  <app-step>
    <nights-two-columns>
      <template v-slot:left>
        <div class="w-full space-y-5">
          <funnel-contact-form @contactFormCompleted="toggleShowPassengers"></funnel-contact-form>
          <transition name="fade">
            <div v-if="showPassengers">
                <app-box-header class="mb-4 passengers-details" v-for="(passenger, index) in passengers" :key="passenger.id"
                  :title="getPassengerLabel(passenger.type, index)">
                  <app-form-adult :refId="`formAdult-${passenger.id}`" :ref="`formAdult-${passenger.id}`"
                    @input="setFormAdultData(passenger.id, $event)" :document-needed="documentNeeded"></app-form-adult>
                    <div v-if="!isPackFlight">
                      <div v-if="index === 0" class="mb-5">
                        {{ $t('shared.first_passenger') }}
                      </div>
                      <h3 class="font-bold mb-3">{{ $t('shared.baggage') }}</h3>
                      <bags-component v-for="extra in extras" :key="extra.id" :extra="extra" :passenger="passenger"
                        @handleClick="changeStatus"></bags-component>
                    </div>
                </app-box-header>

                <v-btn
                  rounded
                  light
                  block
                  elevation="0"
                  color="secondary"
                  @click="handleClick"
                  :loading="loading"
                  class="avm-btn mx-auto xl:hidden"
                >
                  {{ $t('shared.continue') }}
              </v-btn>
            </div>
          </transition>
        </div>
      </template>

      <template v-slot:right>
        <div class="summary-container space-y-5">
          <!-- <app-box-timer class="hidden xl:flex"></app-box-timer> -->
          <box-summary :selectedCategory="selectedCategory" :packHotels="packHotels" :extraNoPromoPercentage="extraNoPromoPercentage" :totalPrice="totalPrice" :totalPriceLuxury="totalPriceLuxury">
            <v-btn
              rounded
              light
              block
              elevation="0"
              color="secondary"
              @click="handleClick"
              :loading="loading"
              class="avm-btn mx-auto"
            >
              {{ $t('shared.continue') }}
            </v-btn>
          </box-summary>
        </div>
      </template>
    </nights-two-columns>
  </app-step>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import BagsComponent from "../common/BagsComponent.vue";
import BoxSummary from "../common/BoxSummary.vue";
import DiscountCodeChecker from "./DiscountCodeChecker.vue";
import NightsTwoColumns from "../common/NightsTwoColumns.vue";
import passengerLabel from "../../../utils/mixins/passengerLabel";
import {
  NIGHTS_SET_PASSENGER_DATA,
  NIGHTS_SET_STATE,
  NIGHTS_TOGGLE_PASSENGER_BAG,
  SET_CONTACT_PACK_AVM,
  SET_RESERVATION_ID
} from "../../../store/nights/mutation-types";
import { GET_DOCUMENT_NEED, GET_TERMS } from "../../../store/booking/getter-types";
import { GET_EXTRA_NO_PROMO_PRICE, GET_NIGHTS_TOTAL_PRICE_WITH_DISCOUNT, NIGHTS_GET_IS_PACK_FLIGHT, NIGHTS_GET_LUXURY_EXTRA, NIGHTS_GET_PACK_HOTELS, NIGHTS_GET_SELECTED_CATEGORY, NIGHTS_GET_TOTAL_PRICE_PACK_LUXURY, NIGHTS_GET_TOTAL_PRICE_PACK_STANDARD } from "../../../store/nights/getter-types";
import { SET_TERMS } from "../../../store/booking/mutation-types";
import { GET_PAYMENT_METHOD } from "../../../store/getter-types";
import { SET_STEPPER_LOADING } from "../../../store/stepper/mutation-types";
import prepareChoice from "../../../utils/prepareReservation";

import { mapMutations, mapGetters } from "vuex";
import { goToStep } from "../mixins";
import NightsMobileBookingSummary from "../common/NightsMobileBookingSummary.vue";

export default {
  components: {
    BagsComponent,
    BoxSummary,
    DiscountCodeChecker,
    NightsTwoColumns,
    NightsMobileBookingSummary
  },
  mixins: [passengerLabel, goToStep],
  data() {
    return {
      showPaypal: false,
      showOverlay: false,
      topTrip: true,
      showPassengers: false
    };
  },
  computed: {
    ...mapGetters({
      isPackFlight: NIGHTS_GET_IS_PACK_FLIGHT,
      packHotels: NIGHTS_GET_PACK_HOTELS,
      selectedCategory:NIGHTS_GET_SELECTED_CATEGORY,
      totalPrice: NIGHTS_GET_TOTAL_PRICE_PACK_STANDARD,
      totalPriceLuxury: NIGHTS_GET_TOTAL_PRICE_PACK_LUXURY,
      extraLuxury: NIGHTS_GET_LUXURY_EXTRA,
      extraNoPromoPercentage: GET_EXTRA_NO_PROMO_PRICE
    }),
    loading() {
      return this.$store.state.stepper.loading;
    },
    totalPriceWithDiscount() {
      return this.$store.getters[GET_NIGHTS_TOTAL_PRICE_WITH_DISCOUNT];
    },
    passengers() {
      return this.$store.state.nights.passengers;
    },
    extras() {
      return this.$store.state.nights.resources.bags;
    },
    documentNeeded() {
      const seat_selected = this.$store.state.nights.extras.find((extra) => extra.id == 2);
      return !seat_selected && this.$store.getters[GET_DOCUMENT_NEED];
    },
  },
  methods: {
    handleClick() {
      if(!this.validate()) return;
      if(!this.isPackFlight) return this.goToStep('pago');

      this.$store.dispatch(SET_STEPPER_LOADING, true);
      axios.post("/api/reservations", {
        reservation: JSON.stringify(prepareChoice("nights")),
        gift: 0,
        nights: 1,
        user_timezone: moment.tz.guess()
      }).then(({data}) => {
        this.setReservationId(data)
        this.goToStep('pago')
      }).finally(() => {
        this.$store.dispatch(SET_STEPPER_LOADING, false);
      })
    },
    ...mapMutations({
      setReservationId: SET_RESERVATION_ID
    }),
    changeStatus(payload) {
      if (!payload.included) {
        this.$store.commit(NIGHTS_TOGGLE_PASSENGER_BAG, {
          passengerId: payload.passengerId,
          bagId: payload.bagId,
        });
      }
    },
    setFormAdultData(passengerId, form) {
      const data = {
        name: form.firstName.value,
        last_name: form.lastName.value,
        email: form.email.value,
        card_id_type: form.idCard.type.value,
        card_id: form.idCard.number.value,
        date_of_birth: new Date(
          form.birthday.year.value,
          form.birthday.month.value - 1,
          form.birthday.day.value,
          12,
          0,
          0
        ),
        nationality: form.nationality.value,
        phone: form.phone.number.value,
        phone_prefix: form.phone.countryCode.value,
        expiration_date: new Date(
          form.expiration_date.year.value,
          form.expiration_date.month.value - 1,
          form.expiration_date.day.value,
          12,
          0,
          0
        ),
      };
      this.$store.commit(NIGHTS_SET_PASSENGER_DATA, { passengerId, data });
    },
    validate() {
      let valid = true;

      valid = valid && this.validateFormAdults();

      if(!valid){
        this.$toastr.e("Datos incompletos");
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }

      return valid;
    },
    validateFormAdults() {
      let valid = true;
      for (let i = 1; i <= this.passengers.length; i++) {
        valid = valid && this.$refs[`formAdult-${i}`][0].validate();
      }

      return valid;
    },
    scrollToBottom() {
      if (window.matchMedia("(min-width: 1280px)").matches) {
        window.scrollTo(0, 9999);
      }
    },
    chooseSubmitMethod() {
      if (this.totalPriceWithDiscount > 0) {
        this.submit();
      } else {
        this.freebooking();
      }
    },
    submit() {
      if (!this.validate()) {
        this.$store.dispatch(SET_STEPPER_LOADING, false);
        return;
      }
    },
    freebooking() {
      if (!this.validate()) {
        return;
      }

      this.showOverlay = true;
      store.commit(NIGHTS_SET_STATE, ["loading", true]);

      axios
        .get("/api/freereservation", {
          params: {
            reservation: prepareChoice("nights"),
          },
        })
        .then((res) => {
          return this.$router.push("/viaje/" + res.data.code + "/confirmacion");
        })
        .catch((err) => {
          console.log(err);
          this.$toastr.e(
            window.i18n.t('toast.error_4')
          );
        })
        .finally(() => {
          this.showOverlay = false;
          store.commit(NIGHTS_SET_STATE, ["loading", false]);
        });
    },
    toggleShowPassengers() {
      this.showPassengers = true;

      this.$nextTick(()=> {
        const divToShow = document.querySelector('.passengers-details');

        if (divToShow) {
          divToShow.scrollIntoView({behavior: 'smooth', block: 'start'})
        }
      })
    }
  },
  created() {
    this.$eventHub.$on("nights-trying-to-pay", this.chooseSubmitMethod);
  },
};
</script>

<style scoped lang="scss">
.summary-container {
  display: none !important;
  float: unset !important;

  @media (min-width: 1280px) {
    display: flex !important;
  }
}
</style>
